import { isEmpty } from 'lodash';

import { PROJECT_STATUSES } from 'constants/commonProjects';
import { PROJECT_ACTION_PLAN, PROJECT_FREQUENCY_TYPE } from 'constants/culturalProject';

export const formatProjectData = (data) => ({
  id: data.id || '',
  organisationId: data.organisation || '',
  organisationName: data.organisation_name || '',
  name: data.name || '',
  status: data.status || PROJECT_STATUSES.DRAFT,
  launchDate: data.launch_date || new Date(),
  endDate: data.end_date || null,
  frequencyType: data.frequency_type || PROJECT_FREQUENCY_TYPE.WEEKLY,
  isPublic: data.is_public,
  repeatEvery: data.repeat_every || 1,
  actionPlanSetting: data.action_plan_setting || PROJECT_ACTION_PLAN.SINGLE,
  journalId: data.journal_id || null,
  wordcloudQuestion: data.wordcloud_question || '',
  dataGroupQuestions: isEmpty(data.data_group_questions)
    ? []
    : data.data_group_questions
        .toSorted((a, b) => a.order - b.order)
        .map((dataGroupQuestion) => ({
          id: dataGroupQuestion.id,
          name: dataGroupQuestion.name,
          surveyQuestion: dataGroupQuestion.survey_question,
          segments: dataGroupQuestion.segments
            .toSorted((a, b) => a.order - b.order)
            .map((segment) => ({
              id: segment.id,
              title: segment.title,
            })),
        })),
  keyAreas: isEmpty(data.key_areas)
    ? []
    : data.key_areas
        .toSorted((a, b) => a.order - b.order)
        .map((keyArea) => ({
          id: keyArea.id,
          name: keyArea.name,
          keyAreaQuestions: isEmpty(keyArea.key_area_questions)
            ? []
            : keyArea.key_area_questions
                .toSorted((a, b) => a.order - b.order)
                .map((keyAreaQuestion) => ({
                  id: keyAreaQuestion.id,
                  culturalPillar: keyAreaQuestion.cultural_pillar,
                  statement: keyAreaQuestion.statement,
                })),
        })),
});
